// extracted by mini-css-extract-plugin
export var boxItems = "_8q-1";
export var boxItemsLg = "_8q-2";
export var button = "_8q-7";
export var buttonHoverless = "_8q-9";
export var buttonLg = "_8q-8";
export var filterGroupBox = "_8q-0";
export var icon = "_8q-3";
export var iconSecondary = "_8q-6";
export var iconWrapper = "_8q-4";
export var iconWrapperLg = "_8q-5";
export var truncatedLabel = "_8q-a";